exports = module.exports = require("../../../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".StandardFieldLayout + .StandardFieldLayout {\n  margin-top: 6px;\n}\n\n.StandardFieldLayout .StandardFieldLayout_Label {\n  min-width: 120px;\n}\n\n.StandardFieldLayout .StandardFieldLayout_Contents > *:first-child {\n  -webkit-box-flex: 1;\n      -ms-flex: 1;\n          flex: 1;\n}\n", ""]);

